import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { elevatorSilenceSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';

export const ElevatorSilenceScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/elevator-silence-scene.png`}
      title="The elevator is silent."
      choices={elevatorSilenceSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
